import requests from '../util';

const { request } = requests;

const fetchUserTasksList = () => {
  return request({
    url: '/api/v1/task/userTaskStats',
    method: 'get',
  });
};



const userTasksApi = {
  fetchUserTasksList,
};

export default userTasksApi;
